export interface ShareApiData {
  text?: string;
  title?: string;
  url?: string;
  files?: File[];
  imageSrc?: string | null;
}

export function useShareApi() {
  const canShare = navigator.canShare;

  const shareData = async ({ text, title, url, files }: ShareData) => {
    try {
      await navigator.share({
        title,
        text,
        url,
        files,
      });
    } catch (e) {
      throw new Error(e);
    }
  };

  return { canShare, shareData };
}
